/** Shared local artwork and tints for the live note and downloaded PNG. */
export const STUDY_NOTE_DECOR = {
  paper: '/assets/classroom-notes/notebook-paper.png',
  header: '/assets/classroom-notes/notebook-header.png',
  footer: '/assets/classroom-notes/notebook-footer.png',
  swoosh: '/assets/classroom-notes/notebook-swoosh.png',
  ring: '/assets/classroom-notes/notebook-ring.png',
  highlight: '/assets/classroom-notes/study-highlight.png',
} as const;

const STUDY_NOTE_TONES = [
  { ring: 'none', brush: 'hue-rotate(35deg) saturate(0.35) brightness(0.93)' },
  { ring: 'hue-rotate(285deg) saturate(1.8)', brush: 'hue-rotate(325deg) saturate(0.8)' },
  { ring: 'hue-rotate(130deg) saturate(1.5)', brush: 'hue-rotate(160deg) saturate(0.55)' },
  { ring: 'hue-rotate(200deg) saturate(1.5)', brush: 'hue-rotate(210deg) saturate(0.65)' },
] as const;

export function studyNoteTone(index: number) {
  return STUDY_NOTE_TONES[index % STUDY_NOTE_TONES.length]!;
}
